namespace Matrix.Exceptions {
    export interface ExceptionPolicyIgnoreRow {
        IgnorePolicyCode?: string;
        Description?: string;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace ExceptionPolicyIgnoreRow {
        export const idProperty = 'IgnorePolicyCode';
        export const nameProperty = 'Description';
        export const localTextPrefix = 'Exceptions.ExceptionPolicyIgnore';
        export const lookupKey = 'Exceptions.ExceptionPolicyIgnore';

        export function getLookup(): Q.Lookup<ExceptionPolicyIgnoreRow> {
            return Q.getLookup<ExceptionPolicyIgnoreRow>('Exceptions.ExceptionPolicyIgnore');
        }
        export const deletePermission = 'DataAdmin:ExceptionPolicyIgnore';
        export const insertPermission = 'DataAdmin:ExceptionPolicyIgnore';
        export const readPermission = 'Read:ExceptionPolicyIgnore';
        export const updatePermission = 'DataAdmin:ExceptionPolicyIgnore';

        export declare const enum Fields {
            IgnorePolicyCode = "IgnorePolicyCode",
            Description = "Description",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
